module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-periodic-table"
  }, [_c('div', {
    staticClass: "c-information d-flex align-items-end"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between w-100"
  }, [_c('countdown', {
    staticClass: "mr-3",
    attrs: {
      "duration": _vm.duration,
      "duration-unit": "minutes",
      "play": _vm.isGameRunning
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gameInput),
      expression: "gameInput"
    }],
    staticClass: "form-control form-control-lg align-self-stretch",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('game.input'),
      "disabled": !_vm.isGameRunning
    },
    domProps: {
      "value": (_vm.gameInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gameInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 text-nowrap"
  }, [_vm._v(_vm._s(_vm.filteredElements.length) + "/118"), _c('br'), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('game.elementsFound')))])])], 1)]), _vm._v(" "), _vm._l((_vm.elements), function(element) {
    return _c('div', {
      staticClass: "element",
      class: element.symbol && element.symbol.toLowerCase(),
      style: ({
        opacity: _vm.filteredElements.includes(element.atomicNumber) ? 1 : 0.25
      }),
      attrs: {
        "data-element-group": element.elementGroup,
        "data-group": element.group,
        "data-period": element.period
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/element/' + element.atomicNumber
      }
    }, [(_vm.filteredElements.includes(element.atomicNumber)) ? _c('element-definition', {
      staticClass: "u-aspect-ratio",
      attrs: {
        "element": element,
        "detailed": true
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "element lanthanoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('lanthanoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "lanthanoid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element actinoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('actinoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "actinoid"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e35ed1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameMode.vue
// module id = 643
// module chunks = 1